import { signInWithCustomToken } from 'firebase/auth';
import { authHubAuth } from '../config/firebase.js';
import { buildApiUrl } from './apiBase.js';

export const signOutEverywhere = async () => {
  try {
    await fetch(buildApiUrl('/api/auth/logout'), {
      method: 'POST',
      credentials: 'include'
    });
  } catch {
    // Cookieが無くても続行する
  }

  await Promise.allSettled([
    authHubAuth.signOut()
  ]);
};

/**
 * Session Cookie が有効なときに Firebase Auth を復元する。
 * GET /api/auth/sso-check の authCustomToken を使用する。
 */
export const restoreFirebaseAuthFromSession = async () => {
  try {
    const response = await fetch(buildApiUrl('/api/auth/sso-check'), {
      method: 'GET',
      credentials: 'include'
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || !data.authenticated || !data.authCustomToken) {
      return false;
    }
    await signInWithCustomToken(authHubAuth, data.authCustomToken);
    return true;
  } catch (err) {
    console.warn('[Auth] Firebase Auth 復元エラー:', err?.message || err);
    return false;
  }
};

/**
 * SSO チェック結果からアプリ state を構築する
 */
export const applySsoSessionData = (data, setUser, setClinic, setLicenses) => {
  if (!data?.authenticated || !data.user) return false;
  setUser({
    uid: data.user.uid,
    email: data.user.email,
    userId: data.user.userId || '',
    displayName: data.user.displayName,
    role: data.user.role,
    clinicId: data.user.clinicId,
    isActive: data.user.isActive,
    avatarUrl: data.user.avatarUrl
  });
  setClinic(data.clinic);
  setLicenses(data.licenses || []);
  return true;
};

/**
 * verify API 応答からアプリ state を構築する
 */
export const applyVerifySessionData = (data, setUser, setClinic, setLicenses) => {
  if (!data?.success || !data.user) return false;
  setUser({
    uid: data.user.uid,
    email: data.user.email,
    userId: data.user.userId || '',
    displayName: data.user.displayName,
    role: data.user.role,
    clinicId: data.user.clinicId,
    isActive: data.user.isActive,
    avatarUrl: data.user.avatarUrl
  });
  setClinic(data.clinic);
  setLicenses(data.licenses || []);
  return true;
};
